export default class EventSubscriptionCounter {
    public counter: Map<number, number> = new Map<number, number>();

    public increment(eventId: number): void {
        const counts = this.counter.get(eventId);

        if (counts) {
            this.counter.set(eventId, counts + 1);
        } else {
            this.counter.set(eventId, 1);
        }
    }

    // todo test, da je bio test ne bi bio bug
    public decrement(eventId: number): void {
        const counts = this.counter.get(eventId);

        if (counts) {
            this.counter.set(eventId, counts - 1);

            if (counts === 0) {
                this.counter.delete(eventId);
            }
        }
    }

    public getAllEventIds(): number[] {
        const keys: number[] = [];
        this.counter.forEach((value, key) => keys.push(key));
        return keys;
    }

    public hasSubscriptions(eventId: number): boolean {
        return !!this.counter.get(eventId);
    }

    public clear() {
        this.counter.clear();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/offer/_private/helpers/EventSubscriptionCounter.ts